import { useEffect, useRef } from 'react';

const FUNCTIONS_BASE = import.meta.env.REACT_APP_URL
  ? import.meta.env.REACT_APP_URL
  : 'https://europe-west1-hotelspot-dev.cloudfunctions.net';

// Budzi funkcje v3 zanim użytkownik ich realnie użyje (cold start ~kilka sekund).
// Backend rozpoznaje `?warmup=1` w handleWarmup i kończy 200 bez autoryzacji —
// dlatego strzał leci bez tokenu i bez credentiali.
export const warmupFunction = (fnNames: string | string[]): void => {
  const names = Array.isArray(fnNames) ? fnNames : [fnNames];
  names.forEach((fnName) => {
    // Rozgrzewka jest best-effort — błąd sieci/CORS nie może wywrócić widoku.
    fetch(`${FUNCTIONS_BASE}/${fnName}?warmup=1`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
    }).catch(() => undefined);
  });
};

export const useWarmup = (functionNames: string | string[]): void => {
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    warmupFunction(functionNames);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
